import Vue from 'vue';
import vuetify from './plugins/vuetify';
import App from './App.vue';
import router from './router';
import store from './store';
import VueCompositionApi from '@vue/composition-api';

import './filters';

Vue.config.productionTip = false;

Vue.use(VueCompositionApi);

export const eventBus = new Vue();

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
}).$mount('#app');
